'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgMiscTrigger = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M11.373 12.09h2.53v1.548H8.032L17.018 3v7.543h4.314l-8.986 10.639v-5.996h1.557v1.74l4.089-4.835H15.46V7.255l-4.088 4.836ZM2 13.417h5.34v-1H2v1Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M10.677 16.07h-8.01v-1h8.01v1ZM4.002 10.765h5.34v-1h-5.34v1Z" })
);

module.exports = SvgMiscTrigger;
//# sourceMappingURL=MiscTrigger.cjs.js.map
